package shared.models

data class PageSEO(
    val title: String,
    val description: String,
    val ogTitle: String? = null,
    val ogDescription: String? = null,
    val ogImage: String? = null,
    val keywords: List<String>? = null,
    val twitterImageAlt: String? = null,
    val canonicalPath: String? = null,
    val robots: String = "index, follow"
)
